module.exports = __webpack_public_path__ + "static/img/after-effects.0b052616.png";